import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";
import { useLanguage } from "context/LanguageContext";
import team1 from "assets/images/team-5.jpg";
import team2 from "assets/images/bruce-mars.jpg";
import team3 from "assets/images/ivana-squares.jpg";
import team4 from "assets/images/ivana-square.jpg";

const processImages = [team1, team2, team3, team4];

function Team() {
  const { messages } = useLanguage();

  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={8}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container item xs={12} md={9} flexDirection="column" sx={{ mb: 6 }}>
          <MKTypography variant="h3" color="white" mb={1}>
            {messages.constructionPage.process.title}
          </MKTypography>
          <MKTypography variant="body2" color="white" opacity={0.85}>
            {messages.constructionPage.process.description}
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          {messages.constructionPage.process.steps.map((step, index) => (
            <Grid item xs={12} lg={6} key={step.name}>
              <MKBox mb={{ xs: 1, lg: 0 }}>
                <HorizontalTeamCard
                  image={processImages[index]}
                  name={step.name}
                  position={{ color: "info", label: step.label }}
                  description={step.description}
                />
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
